import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConnectorListState } from '../../actions/types/connectors/GetConnectorListTypes';

/**
 * Initial Dashboard state in store
 */
export const initialState: ConnectorListState = {
  isLoading: false,
  isTrackerLoading: true,
  iseventDetailsLoading: true,
  success: false,
  errorMessage: '',
  connectorListDetails: []
};

/**
 * get metric summary Slice to get metric
 */
export const getConnectorListSlice = createSlice({
  name: 'getMetricsSummary',
  initialState,
  reducers: {
    getConnectorListStarted: (state) => {
      state.isLoading = true;
    },

    getConnectorListSuccess: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.success = true;
      state.errorMessage = '';
      state.connectorListDetails = action.payload;
    },

    getConnectorListFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = action.payload;
      state.connectorListDetails = initialState.connectorListDetails;
    },

    clearConnectorList: (state) => {
      state.isLoading = false;
      state.success = false;
      state.errorMessage = '';
      state.connectorListDetails = initialState.connectorListDetails;
    }
  }
});

export const { getConnectorListStarted, getConnectorListSuccess, getConnectorListFail, clearConnectorList } = getConnectorListSlice.actions;
export default getConnectorListSlice.reducer;
